import React from 'react';
import Box from '@mui/material/Box';

import Modal from '@mui/material/Modal';

import '../../VendorStyles/DeleteOfferModal.css';
import CloseIcon from '../../assets/svg/closeIcon';

function DeleteOfferModal({ open, handleClose, confirmDelete, cancelDelete, message = 'Are you sure you want to delete this item?' }) {
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="offer-delete-container">
                    <div className="delete-modal-content">
                        <div className="title-close-container">
                            <p className="offer-text">{message}</p>
                            <CloseIcon
                                size={30}
                                color='black'
                                onClick={handleClose}
                                className='close-icon'
                            />
                        </div>

                        <div className="btns-delete-modals">
                            <button className="confirm-delete-btn" onClick={confirmDelete}>
                Delete
                            </button>
                            <button className="cancel-delete-btn" onClick={cancelDelete}>
                Cancel
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default DeleteOfferModal;
